import { ComponentChildren } from 'preact';

type AccordionSettings = {
  enabled?: boolean;
};

export const Accordion = ({
  uid,
  children,
  settings,
}: {
  uid: string;
  children: ComponentChildren;
  settings?: AccordionSettings;
}) => {
  const accordionIdClass = `cc-accordion-${uid}`;
  const enabledClass = settings?.enabled ?? true ? 'stack-enable' : 'stack-disable';

  const accordionToggleProperties: { [name: string]: any } = {};
  if (!(settings?.enabled ?? true)) accordionToggleProperties['checked'] = false;

  return (
    <div class={`cc-accordion ${accordionIdClass} ${enabledClass}`}>
      <input
        type="checkbox"
        class="hide-by-default cc-accordion-header-toggle"
        name={uid}
        id={uid}
        {...accordionToggleProperties}
      />
      {children}
    </div>
  );
};
